/* TradingAces shop JS: collection filters, price sheet sort, gallery, variants, qty, sticky ATC.
   Vanilla, defensive, safe to load more than once. */
(function () {
  'use strict';
  if (window.__taShopLoaded) return;
  window.__taShopLoaded = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false, addEventListener: function () {} }; };
  var reduced = function () { return (window.TA && window.TA.reducedMotion) || mq('(prefers-reduced-motion: reduce)').matches; };
  function on(mql, fn) { if (mql.addEventListener) mql.addEventListener('change', fn); else if (mql.addListener) mql.addListener(fn); }

  /* ---------- Collection: native filters (GET form) ---------- */
  function initCollection(root) {
    if (root.__taInit) return; root.__taInit = true;
    var form = $('[data-ta-filter-form]', root);
    if (form) {
      var submitTimer;
      var submit = function () {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        }, 250);
      };
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-ta-instock]')) return;
        if (t.matches('input, select')) submit();
      });
      // Drop empty price inputs so URLs stay clean
      form.addEventListener('submit', function () {
        $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      });

      // Mobile: filters collapsed behind one toggle. Desktop: always open, dropdowns.
      var wrap = $('[data-ta-filters]', form);
      if (wrap) {
        var desk = mq('(min-width: 800px)');
        var sync = function () { wrap.open = desk.matches ? true : wrap.hasAttribute('data-was-open'); };
        wrap.addEventListener('toggle', function () {
          if (!desk.matches) { if (wrap.open) wrap.setAttribute('data-was-open', ''); else wrap.removeAttribute('data-was-open'); }
        });
        if (!desk.matches) wrap.open = false;
        on(desk, sync);
      }
      // Dropdowns: one open at a time on desktop, close on outside click / Escape
      var drops = $$('.ta-fdrop', form);
      drops.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open && mq('(min-width: 800px)').matches) drops.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
      document.addEventListener('click', function (e) {
        if (!mq('(min-width: 800px)').matches) return;
        drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
      });
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') drops.forEach(function (d) { if (d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); } });
      });
    }
    initClientFilters(root);
  }

  /* ---------- Collection: client-side chips (sports) + in-stock fallback ---------- */
  function initClientFilters(root) {
    var cards = $$('[data-ta-grid] .ta-card', root);
    var nomatch = $('[data-ta-nomatch]', root);
    var cf = $('[data-ta-cf]', root);
    var stockWrap = $('[data-ta-instock-wrap]', root);
    var stockBox = $('[data-ta-instock]', root);
    if (!cards.length) return;

    var state = { sport: {}, vendor: {}, type: {} };
    var labels = { sport: {}, vendor: {}, type: {} };
    var inStockOnly = false;
    var groupDefs = [['sport', 'Sport'], ['vendor', 'Brand'], ['type', 'Box type']];
    var chipEls = {};
    var statusEl, clearBtns;

    var tagsOf = function (c) { return (c.getAttribute('data-tags') || '').split(',').filter(Boolean); };
    var valuesOf = function (c, g) {
      if (g === 'sport') return tagsOf(c).filter(function (t) { return labels.sport[t]; });
      var v = c.getAttribute(g === 'vendor' ? 'data-vendor' : 'data-type');
      return v ? [v] : [];
    };
    var isOut = function (c) { return !!c.querySelector('.ta-stock--out'); };
    var matches = function (c, skip) {
      if (inStockOnly && isOut(c)) return false;
      for (var i = 0; i < groupDefs.length; i++) {
        var g = groupDefs[i][0];
        if (g === skip) continue;
        var sel = Object.keys(state[g]);
        if (!sel.length) continue;
        var vals = valuesOf(c, g);
        if (!sel.some(function (s) { return vals.indexOf(s) > -1; })) return false;
      }
      return true;
    };
    var anySelected = function () { return groupDefs.some(function (d) { return Object.keys(state[d[0]]).length; }) || inStockOnly; };

    var apply = function () {
      var shown = 0;
      cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) shown++; });
      if (nomatch) nomatch.hidden = shown > 0;
      if (cf) {
        groupDefs.forEach(function (d) {
          var g = d[0];
          Object.keys(chipEls[g] || {}).forEach(function (val) {
            var n = cards.filter(function (c) { return matches(c, g) && valuesOf(c, g).indexOf(val) > -1; }).length;
            var el = chipEls[g][val];
            el.querySelector('.ta-cf__n').textContent = n;
            el.setAttribute('aria-pressed', state[g][val] ? 'true' : 'false');
          });
        });
        statusEl.textContent = 'Showing ' + shown + ' of ' + cards.length;
      }
      clearBtns.forEach(function (b) { b.hidden = !anySelected(); });
    };

    clearBtns = $$('[data-ta-cf-clear]', root);
    var clearAll = function () {
      state = { sport: {}, vendor: {}, type: {} };
      inStockOnly = false;
      if (stockBox) stockBox.checked = false;
      apply();
    };
    clearBtns.forEach(function (b) { b.addEventListener('click', clearAll); });

    if (cf) {
      var json = $('[data-ta-labels]', root);
      try { if (json) labels = JSON.parse(json.textContent); } catch (e) {}
      ['sport', 'vendor', 'type'].forEach(function (g) { labels[g] = labels[g] || {}; });
      var groupsEl = $('[data-ta-cf-groups]', cf);
      statusEl = $('[data-ta-cf-status]', cf);
      groupDefs.forEach(function (d) {
        var g = d[0];
        var present = {};
        cards.forEach(function (c) { valuesOf(c, g).forEach(function (v) { present[v] = 1; }); });
        var keys = Object.keys(present);
        if (g === 'sport') { var order = Object.keys(labels.sport); keys.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); }); }
        else keys.sort(function (a, b) { return (labels[g][a] || a).localeCompare(labels[g][b] || b); });
        if (keys.length < 2 && g !== 'sport') return;
        if (!keys.length) return;
        var fs = document.createElement('div');
        fs.className = 'ta-cf__group';
        fs.setAttribute('role', 'group');
        var lid = 'ta-cf-' + g;
        fs.setAttribute('aria-labelledby', lid);
        var lab = document.createElement('span');
        lab.className = 'ta-label'; lab.id = lid; lab.textContent = d[1];
        fs.appendChild(lab);
        var row = document.createElement('div');
        row.className = 'ta-cf__chips';
        chipEls[g] = {};
        keys.forEach(function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ta-tab ta-cf__chip';
          b.setAttribute('aria-pressed', 'false');
          b.innerHTML = '<span></span> <span class="ta-cf__n"></span>';
          b.firstChild.textContent = labels[g][k] || k;
          b.addEventListener('click', function () {
            if (state[g][k]) delete state[g][k]; else state[g][k] = true;
            apply();
          });
          chipEls[g][k] = b;
          row.appendChild(b);
        });
        fs.appendChild(row);
        groupsEl.appendChild(fs);
      });
      cf.hidden = false;
    }

    if (stockWrap && stockBox) {
      // Only offered when the native availability filter is not enabled in Search & Discovery
      if (cards.some(isOut)) {
        stockWrap.hidden = false;
        stockBox.addEventListener('change', function () { inStockOnly = stockBox.checked; apply(); });
      }
    }
    if (cf || (stockWrap && !stockWrap.hidden)) { if (statusEl || clearBtns.length) apply(); }
  }

  /* ---------- Full price sheet: sortable table, merges all pages ---------- */
  function initPriceIndex(root) {
    if (root.__taInit) return; root.__taInit = true;
    var table = $('[data-ta-pi-table]', root);
    var body = $('[data-ta-pi-body]', root);
    if (!table || !body) return;
    var state = { key: null, dir: 1 };

    var cell = function (tr, key) {
      switch (key) {
        case 'title': return (tr.getAttribute('data-title') || '').toLowerCase();
        case 'market': return parseFloat(tr.getAttribute('data-market'));
        case 'ours': return parseFloat(tr.getAttribute('data-ours'));
        case 'status': return parseFloat(tr.getAttribute('data-status'));
        case 'chg': var v = tr.getAttribute('data-chg'); return v === '' || v == null ? null : parseFloat(v);
      }
      return 0;
    };
    var sortRows = function () {
      if (!state.key) return;
      var rows = $$('tr', body);
      rows.sort(function (a, b) {
        var x = cell(a, state.key), y = cell(b, state.key);
        if (x === null && y === null) return 0;
        if (x === null) return 1;      // blanks always last
        if (y === null) return -1;
        if (typeof x === 'string') return x.localeCompare(y) * state.dir;
        return ((x > y) - (x < y)) * state.dir;
      });
      rows.forEach(function (r) { body.appendChild(r); });
      $$('thead th', table).forEach(function (th) {
        var b = $('[data-sort]', th);
        if (!b) return;
        th.setAttribute('aria-sort', b.getAttribute('data-sort') === state.key ? (state.dir > 0 ? 'ascending' : 'descending') : 'none');
      });
    };
    $$('[data-sort]', table).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-sort');
        if (state.key === k) state.dir = -state.dir; else { state.key = k; state.dir = 1; }
        sortRows();
      });
    });

    var refresh7d = function () {
      var any = $$('tr', body).some(function (r) { var v = r.getAttribute('data-chg'); return v !== '' && v != null; });
      table.classList.toggle('has-7d', any);
    };

    // Pull in the remaining pages so sorting covers every product (the pager stays as the no-JS path).
    var pager = $('[data-ta-pi-pager]', root);
    var next = pager && $('a[rel="next"]', pager);
    if (!window.fetch || !window.DOMParser || !next) { refresh7d(); return; }
    var guard = 0;
    var newest = 0;
    var loadNext = function (href) {
      if (!href || guard++ > 12) return Promise.resolve();
      return fetch(href, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-ta-pi-body] tr', doc).forEach(function (tr) {
          body.appendChild(document.importNode(tr, true));
          newest = Math.max(newest, parseInt(tr.getAttribute('data-upd') || '0', 10));
        });
        var n = $('[data-ta-pi-pager] a[rel="next"]', doc);
        return n ? loadNext(n.getAttribute('href')) : null;
      });
    };
    loadNext(next.getAttribute('href')).then(function () {
      if (pager) pager.hidden = true;
      var chk = $('[data-ta-checked]', root);
      if (chk && newest > parseInt(chk.getAttribute('data-ta-checked') || '0', 10)) {
        chk.setAttribute('data-ta-checked', String(newest));
        document.dispatchEvent(new CustomEvent('ta:checked:refresh'));
        if (window.TA && typeof window.TA.refreshChecked === 'function') window.TA.refreshChecked();
      }
      refresh7d(); sortRows();
    }).catch(function () { refresh7d(); });
    refresh7d();
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (root.__taInit) return; root.__taInit = true;

    /* gallery */
    var gal = $('[data-ta-gallery]', root);
    var slides = gal ? $$('[data-ta-slide]', gal) : [];
    var thumbs = gal ? $$('[data-ta-thumb]', gal) : [];
    var selectMedia = function (id) {
      var hit = false;
      slides.forEach(function (s) { var m = s.getAttribute('data-media-id') === String(id); s.hidden = !m; if (m) hit = true; });
      if (!hit) return false;
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-media-id') === String(id) ? 'true' : 'false'); });
      return true;
    };
    if (slides.length && !slides.some(function (s) { return !s.hidden; })) { slides[0].hidden = false; if (thumbs[0]) thumbs[0].setAttribute('aria-pressed', 'true'); }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectMedia(t.getAttribute('data-media-id')); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % thumbs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + thumbs.length) % thumbs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = thumbs.length - 1;
        if (j === null) return;
        e.preventDefault();
        thumbs[j].focus(); thumbs[j].click();
      });
    });

    /* elements */
    var form = $('.ta-buyform', root);
    var qty = $('[data-ta-qty]', root);
    var mainAdd = $('[data-ta-main-add]', root);
    var fallback = $('[data-ta-fallback]', root);
    var stickyAdd = $('[data-ta-sticky-add]');
    var sticky = $('[data-ta-sticky]');
    var buyRow = $('[data-ta-buyrow]', root);
    var notify = $('[data-ta-notify]', root);
    var variants = [];
    try { variants = JSON.parse($('[data-ta-variants]', root).textContent) || []; } catch (e) {}
    var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });
    var soldOut = !!(notify && !notify.hidden);

    if (mainAdd) { mainAdd.hidden = false; if (fallback) fallback.hidden = true; }

    /* qty stepper */
    var clamp = function () {
      var n = parseInt(qty && qty.value, 10);
      if (!(n >= 1)) n = 1; if (n > 99) n = 99;
      if (qty) qty.value = n;
      return n;
    };
    var syncQty = function () {
      var n = clamp();
      [mainAdd, stickyAdd].forEach(function (b) { if (b) b.setAttribute('data-qty', String(n)); });
    };
    $$('[data-ta-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-ta-qty-step'), 10);
        syncQty();
      });
    });
    if (qty) { qty.addEventListener('input', syncQty); qty.addEventListener('change', syncQty); }
    if (form) form.addEventListener('submit', function (e) {
      if (mainAdd && !mainAdd.hidden) { e.preventDefault(); syncQty(); mainAdd.click(); }
    });

    /* variants */
    var setText = function (sel, txt) { $$(sel, root).forEach(function (el) { el.textContent = txt; }); };
    var applyVariant = function (v) {
      if (!v) return;
      var pp = $('[data-ta-pp]', root), only = $('[data-ta-priceonly]', root);
      if (pp) {
        pp.hidden = !v.tcg;
        if (only) only.hidden = !!v.tcg;
        var cmp = $('[data-ta-cmp]', pp);
        if (cmp) cmp.className = cmp.className.replace(/ta-cmp--(match|above|below|none)/g, '').trim() + ' ta-cmp--' + v.status;
        setText('[data-ta-ours]', v.price);
        setText('[data-ta-mkt]', v.market);
        var st = $('[data-ta-status]', pp); if (st) st.innerHTML = v.statusHtml || '';
        var link = $('[data-ta-tcg-link]', pp);
        if (link) { if (v.tcgUrl) { link.href = v.tcgUrl; link.hidden = false; } else link.hidden = true; }
        var chk = $('[data-ta-checked]', pp);
        if (chk && String(v.checked) !== chk.getAttribute('data-ta-checked')) {
          chk.setAttribute('data-ta-checked', String(v.checked));
          chk.hidden = !v.checked;
          document.dispatchEvent(new CustomEvent('ta:checked:refresh'));
          if (window.TA && typeof window.TA.refreshChecked === 'function') window.TA.refreshChecked();
        }
      }
      setText('[data-ta-ours-only]', v.price);
      var stock = $('[data-ta-stock]', root);
      if (stock) { stock.textContent = v.stock; stock.hidden = !v.stock; }
      var so = $('[data-ta-soldout]', root); if (so) so.hidden = !!v.available;
      if (buyRow) buyRow.hidden = !v.available;
      if (notify) notify.hidden = !!v.available;
      soldOut = !v.available;
      var nb = $('[data-ta-notify-body]', root);
      if (nb) nb.value = 'Notify me: ' + nb.getAttribute('data-title') + (variants.length > 1 ? ' - ' + v.title : '') + ' (' + nb.getAttribute('data-url') + (variants.length > 1 ? '?variant=' + v.id : '') + ')';
      [mainAdd, stickyAdd].forEach(function (b) { if (b) b.setAttribute('data-ta-add', String(v.id)); });
      var sp = $('[data-ta-sticky-price]'); if (sp) sp.textContent = v.price;
      var ppp = $('[data-ta-ppp]', root); if (ppp && v.ppp) ppp.textContent = v.ppp;
      $$('[data-ta-chart-for]', root).forEach(function (c) { c.hidden = c.getAttribute('data-ta-chart-for') !== String(v.id); });
      if (v.media) selectMedia(v.media);
      if (window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      updateSticky();
    };
    $$('[data-ta-variant]', root).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) applyVariant(byId[r.value]); });
    });

    /* sticky add-to-cart (under 1000px via CSS), shown once the main buy row scrolls above the viewport */
    var past = false;
    function updateSticky() {
      if (!sticky) return;
      var show = past && !soldOut;
      sticky.hidden = !show;
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('ta-has-sticky', show);
    }
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        updateSticky();
      }, { threshold: 0 }).observe(buyRow);
    }
    syncQty();
  }

  function boot(scope) {
    $$('[data-ta-collection]', scope).forEach(initCollection);
    $$('[data-ta-pi]', scope).forEach(initPriceIndex);
    $$('[data-ta-product]', scope).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
